import { render } from "./EditSurvey.vue?vue&type=template&id=7339dbc6&scoped=true"
import script from "./EditSurvey.vue?vue&type=script&lang=js"
export * from "./EditSurvey.vue?vue&type=script&lang=js"

import "./EditSurvey.vue?vue&type=style&index=0&id=7339dbc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7339dbc6"]])

export default __exports__